import {Container} from "./Container"

export const ManagerStyles = {
    Container: Container
}